import { useSync, SYNC_LABELS } from '../context/SyncContext';

// Chỉ báo nổi góc dưới phải — hiện khi đang đồng bộ (xuất hiện ở mọi màn).
export default function SyncIndicator() {
  const { running, progress } = useSync();
  if (!running) return null;
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 18,
        right: 18,
        maxWidth: 360,
        background: 'var(--panel)',
        border: '1px solid var(--accent)',
        borderRadius: 12,
        padding: '12px 14px',
        boxShadow: '0 12px 30px rgba(40,60,120,.18)',
        zIndex: 80,
        fontSize: 13,
      }}
    >
      <div className="row" style={{ gap: 8, alignItems: 'center' }}>
        <span
          style={{
            width: 14,
            height: 14,
            border: '2px solid var(--accent)',
            borderTopColor: 'transparent',
            borderRadius: '50%',
            display: 'inline-block',
            animation: 'ftspin 0.8s linear infinite',
          }}
        />
        <b>Đang đồng bộ: {SYNC_LABELS[running] || running}</b>
      </div>
      <div className="small muted" style={{ marginTop: 6 }}>
        {progress || 'Đang chạy…'}
      </div>
      <style>{`@keyframes ftspin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
